import { z } from 'zod';

export const emailSupportSchema = z.object({
  name: z.string(),
  email: z.string(),
  role: z.string(),
  subject: z.string().min(1, 'Subject is required'),
  details: z
    .string()
    .min(10, 'Please provide more details (minimum 10 characters)'),
  attachments: z.any().optional(), // File upload field
});

export const emailSupportDefaultValues = {
  subject: '',
  details: '',
  attachments: null,
};

export type EmailSupportFormType = z.infer<typeof emailSupportSchema>;

export const reportDisputeFormSchema = emailSupportSchema.extend({
  category: z.string().min(1, 'Category is required'),
});

export const reportDisputeDefaultValues = {
  ...emailSupportDefaultValues,
  category: '',
};

export type ReportDisputeFormType = z.infer<typeof reportDisputeFormSchema>;
